import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { ProductDetailsContext } from '../context';
import { messages } from '../messages';

import style from '../style.module.less';

const EMPTY_CONFIRMATION_ID = '';

const getDefaultText = (isInternational) => {
  if (isInternational) {
    return <FormattedMessage {...messages.defaultInternationalConfirmation} />;
  }
  return <FormattedMessage {...messages.defaultConfirmation} />;
};

export const ProductDetailsConfirmationDropdown = ({
  selectedConfirmationName = '',
  confirmations,
  onConfirmationChanged,
  isEnabled = false,
  isInternational = false,
}) => {
  const { userHasPermission } = useContext(ProductDetailsContext);
  const defaultConfirmationText = getDefaultText(isInternational);

  return (
    <DropdownMenu
      data-testid={isInternational ? 'international-confirmation' : 'domestic-confirmation'}
      disabled={!userHasPermission || !isEnabled}
      dropdownMenuShouldHaveWidthOfButton
      fullWidth
      title={selectedConfirmationName}
      variant='form'
    >
      <DropdownMenuToggler className={style['dropdown-picker']} disabled={!userHasPermission || !isEnabled}>
        {selectedConfirmationName || defaultConfirmationText}
      </DropdownMenuToggler>
      <DropdownMenuItem onClick={() => onConfirmationChanged(EMPTY_CONFIRMATION_ID)}>
        <FormattedMessage {...messages.none} />
      </DropdownMenuItem>
      {confirmations.map(({ confirmationId, name }) => (
        <DropdownMenuItem key={confirmationId} onClick={() => onConfirmationChanged(confirmationId)}>
          {name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

ProductDetailsConfirmationDropdown.propTypes = {
  selectedConfirmationName: PropTypes.string,
  confirmations: PropTypes.array.isRequired,
  isEnabled: PropTypes.bool,
  onConfirmationChanged: PropTypes.func.isRequired,
  isInternational: PropTypes.bool,
};
